export const DEFAULT_NOTIFICATIONS_PAGINATION = {
  page: 1,
  itemsPerPage: 10
};

export const REFETCH_NOTIFICATIONS_COUNTS_INTERVAL = {
  milliseconds: 300000
};